type Connector = (
  node: HTMLElement,
  events: string[],
  callback: (e: NativePointerEvent) => void
) => void;

export function eventHandlerConnectFactory(type: 'add' | 'remove'): Connector {
  return function connect(
    node: HTMLElement,
    events: string[],
    callback: (e: NativePointerEvent) => void
  ) {
    events.forEach((event: string) => {
      if (type === 'add') node.addEventListener(event, callback);
      else node.removeEventListener(event, callback);
    });
  };
}

export const connectHandlers = eventHandlerConnectFactory('add');
export const disconnectHandlers = eventHandlerConnectFactory('remove');
